export default (apiMethods, endpoints) => ({
    getMerchants: () => {
        return apiMethods.get(endpoints.GET_MERCHANTS_ENDPOINT);
    },
    addMerchant: (data) => {
        return apiMethods.post(endpoints.ADD_MERCHANT_ENDPOINT, data);
    },
    deleteMerchant: (merchantId) => {
        return apiMethods.delete(endpoints.DELETE_MERCHANT_ENDPOINT + '/' + merchantId)
    },
    getMerchantProducts: () => {
        return apiMethods.get(endpoints.GET_MERCHANT_PRODUCTS_ENDPOINT);
    },
    unblockMerchant: (data) => {
        return apiMethods.post(endpoints.UNBLOCK_MERCHANT_ENDPOINT, data);
    }
})



// WEBPACK FOOTER //
// ./src/lib/api-merchant.js